import React, { Dispatch, SetStateAction } from 'react';
import { Srp30ConfigService } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/SrpConfigService/Srp30ConfigService';
import { CustomBackdrop, Header, NavHeader, Page, SubmitButton } from '../../../../../../../components';
import { ROUTES } from '../../../../../../../routes/routes';
import { ChannelBoxIcon } from '../../../../../components/channel/box-icon';
import { useConfigurationService } from '../../../../device-details/hooks/use-configuration-service';
import { useCalibration } from '../hooks/use-calibration';
import './index.scss';

type AutoCalibrationBlind0Props = {
  setStep: Dispatch<SetStateAction<number>>;
};

const AutoCalibrationBlind0: React.FC<AutoCalibrationBlind0Props> = ({ setStep }) => {
  const { channel, navigate, t } = useCalibration();
  const { configService: serviceName } = useConfigurationService(channel?.GetDevice());

  const handleClick = async () => {
    const step = serviceName === Srp30ConfigService.ServiceName ? 1 : 2;
    setStep(step);
    navigate(`${ROUTES.BlindAutoCalibration(channel?.ChannelId)}?step=${step}`);
  };

  return (
    <Page
      className="auto-calibration-flow"
      isStickyHeader
      whiteContent
      header={
        <>
          <NavHeader />
          <Header title={t('exalus.calibration')} />
        </>
      }
    >
      {channel && <ChannelBoxIcon channel={channel} className="blind-icon" />}
      <p className="channel-name">{channel?.Name}</p>

      <p className="info m-t-48">{t('exalus.autoCalibrationFlow.welcome')}</p>
      {serviceName === Srp30ConfigService.ServiceName && (
        <p className="info--sub">{t('exalus.autoCalibrationFlow.nextInfo')}</p>
      )}
      <SubmitButton type="button" onClick={handleClick} tranparent>
        {t('exalus.autoCalibrationFlow.next')}
      </SubmitButton>
      {!channel && <CustomBackdrop loading />}
    </Page>
  );
};

export default AutoCalibrationBlind0;
